// js
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import OverviewIndexedDataSummary from '../OverviewIndexedDataSummary';
import OverviewAreaItem from './OverviewAreaItem';
// css
import '../../../styles/components/analytics/Overview.scss';


class Overview extends Component {

  renderAreas() {
    const { activeAreas, areaStats } = this.props;

    return activeAreas.map((area, index) => (
      <OverviewAreaItem
        key={index}
        area={area}
        stats={areaStats[area.id]}
      />
    ));
  }

  render() {
    const { totalStats } = this.props;
    let dataPerDay = (totalStats.dataRequired * totalStats.peakBuffer) + Number(totalStats.dataRequired);

    return (
      <div className='analytics__overview__pptx' id={this.props.pptxTarget}>
        <div className='row'>
          <div className='col-md-10 col-md-offset-1 analytics__overview__titles'>
            <h3>Indexing {totalStats.percentIndexed}% of required data</h3>
            <p>Based on key data sources identified by participants and required to achieve key goals</p>
            <hr />
          </div>
        </div>
        <div className='row'>
          <div className='col-md-10 col-md-offset-1 analytics__overview__progress-bar-container'>
            <OverviewIndexedDataSummary
              progressBarHeight={40}
              progressBarStripeColor='white'
              stats={totalStats}
            />
            <p className='analytics__overview-indexed-data-summary__indexed-per-day'>Peak buffer {totalStats.peakBuffer * 100}% &middot; {dataPerDay.toFixed(1)} GB Total Environment Data Per Day</p>
          </div>
        </div>
      </div>
    );
  }
}

Overview.propTypes = {
  activeAreas: PropTypes.array.isRequired,
  totalStats: PropTypes.object,
  areaStats: PropTypes.object,
  pptxTarget: PropTypes.string
};

export default Overview;



// WEBPACK FOOTER //
// ./src/components/analytics/pptx/Overview.js